<template>
  <div>
    <div class='app-container'>
      <div class='dovemed-wrapper py-4'>
        <div class='row'>
          <div class='col-md-4 col-lg-4 d-account-menu'>
            <div class='dovemed-card home-tab'>
              <router-link :to="{ name: 'YourActivity'}"> YOUR ACTIVITY</router-link>
              <router-link :to="{ name: 'AccountSettings'}"> ACCOUNT SETTINGS</router-link>
              <router-link :to="{ name: 'NotificationSettings'}"> NOTIFICATION SETTINGS</router-link>
            </div>
          </div>
          <div class='col-md-8 col-lg-8 col-sm-12 col-xs-12'>
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Account'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/account/Account.vue